import React from 'react';
import IconBase from './Icon-base';
export default class Rotate extends React.Component {
    render() {
        return (
            <IconBase width="33" height="28" viewBox="0 0 33 28" {...this.props}>
                <g id="Canvas_rotR" transform="translate(-109 234)">
                    <g id="Group 2_rot">
                        <g id="Subtract_rot">
                            <use
                                xlinkHref="#path0_fill_rot"
                                transform="translate(109 -232)"
                                fill="#4F5056"
                            />
                        </g>
                        <g id="Subtract">
                            <use
                                xlinkHref="#path1_fill_rot"
                                transform="translate(118 -220)"
                                fill="#4F5056"
                            />
                        </g>
                        <g id="Rotate Icon-path">
                            <use
                                xlinkHref="#path2_fill_rot"
                                transform="matrix(6.12323e-17 -1 -1 -6.12323e-17 137 -221)"
                                fill="#4F5056"
                            />
                        </g>
                    </g>
                </g>
                <defs>
                    <path
                        id="path0_fill_rot"
                        fillRule="evenodd"
                        d="M 2 1L 12 1C 12.5523 1 13 1.44771 13 2L 13 20C 13 20.5523 12.5523 21 12 21L 11 21L 11 22L 12 22C 13.1046 22 14 21.1046 14 20L 14 2C 14 0.895432 13.1046 0 12 0L 2 0C 0.89543 0 0 0.895432 0 2L 0 20C 0 21.1046 0.89543 22 2 22L 8 22L 8 21L 2 21C 1.44772 21 1 20.5523 1 20L 1 2C 1 1.44771 1.44772 1 2 1Z"
                    />
                    <path
                        id="path1_fill_rot"
                        fillRule="evenodd"
                        d="M 3 0L 2 0C 0.895432 0 0 0.895432 0 2L 0 12C 0 13.1046 0.895432 14 2 14L 22 14C 23.1046 14 24 13.1046 24 12L 24 2C 24 0.895432 23.1046 0 22 0L 6 0L 6 1L 22 1C 22.5523 1 23 1.44771 23 2L 23 12C 23 12.5523 22.5523 13 22 13L 2 13C 1.44772 13 1 12.5523 1 12L 1 2C 1 1.44771 1.44772 1 2 1L 3 1L 3 0Z"
                    />
                    <path
                        id="path2_fill_rot"
                        fillRule="evenodd"
                        d="M 13 9.77778C 13 10.5547 12.8654 11.3004 12.6249 12L 11.6355 12C 11.9131 11.3089 12.0714 10.5613 12.0714 9.77778C 12.0714 6.34667 9.15571 3.55556 5.57143 3.55556L 5.57143 6.22222L 0 3.11111L 5.57143 0L 5.57143 2.66667C 9.67386 2.66667 13 5.85067 13 9.77778L 13 9.77778Z"
                    />
                </defs>
            </IconBase>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/DocumentViewer/src/SVGIcons/Rotate.js